import { useRef } from 'react'
import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'
import AlertCustom from '../../components/Alerts'
import { AlertContext } from '../../context/AlertContext'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import HeaderComponent from '../../components/HomePageComponents/HeaderComponent/HeaderComponent'
import FooterComponent from '../../components/HomePageComponents/FooterComponent/FooterComponent'
import * as RT from '../../config/routeType'
import { useLocation } from 'react-router-dom'
import './css/main.css'

const HomePage = ({ isAuth }) => {
  const alertRef = useRef()
  const location = useLocation()
  const isRoutes = [
    `/${RT.ABOUT}`,
    `/${RT.TEAM}`,
    `/${RT.NEWS}`,
    `/${RT.CONTACT}`,
    `/${RT.PUBLICATIONS}`,
  ].includes(location.pathname)

  return (
    <AlertContext.Provider value={{ alertRef }}>
      <Box sx={{ height: '100vh', mt: 'auto' }}>
        {isRoutes && <HeaderComponent isAuth={isAuth} />}
        <Outlet />
        <AlertCustom ref={alertRef} severity="warning" />
        {isRoutes && <FooterComponent />}
      </Box>
    </AlertContext.Provider>
  )
}

export default HomePage
